import {Injectable} from '@angular/core';
import {ConfigService} from '@labshare/ngx-core-services';
import {ApiUrlConfigKeys, AsrRoutePath} from '../constants';

@Injectable({providedIn: 'root'})
export class ApiServiceUtils {
  constructor(private config: ConfigService) {}
  public asrApiBaseUrl: string = this.config.get(ApiUrlConfigKeys.AsrServicesUrl);
  public authUrl: string = this.config.get(ApiUrlConfigKeys.ServicesAuthUrl);
  public tenant: string = this.config.get(ApiUrlConfigKeys.ServicesAuthTenant);

  getApiUrl() {
    return this.asrApiBaseUrl + this.getFacilityUrl();
  }

  getFacilityUrl() {
    return [this.tenant, AsrRoutePath.ASR_URL].join('/');
  }

  getFileStorageUrl() {
    return this.config.get(ApiUrlConfigKeys.AsrFileStorageUrl);
  }
}
